module.exports = __webpack_public_path__ + "img/plexus-4.7734a73c.png";